import mwcMarketsCore from 'mwc-markets-core';
import Quote from './src/quote.vue';

const { createCustomElement } = mwcMarketsCore;
createCustomElement(Quote);

export default Quote;
